import HttpService from './HttpService';

const OverviewReportApi = HttpService('api/overviewreport/');
const doGet = (url) => OverviewReportApi.get(url);


export default {
  getOverviewReport(activeSiteId) {
    const queryString = `activeSiteId=${activeSiteId}`;
    const apiAction = 'GetVesselOverviewReport';
    const fullUrl = queryString ? `${apiAction}?${queryString}` : apiAction;
    return doGet(fullUrl);
  },
};
